import React from "react";
import ReactApexChart from "react-apexcharts";

const DonutChart = ({ graph }) => {
  const chartData = {
    series: graph?.totalData,
    options: {
      chart: {
        type: "donut",
      },
      labels: graph?.totalCategory || [],
      legend: {
        position: "bottom",
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={280}
        />
      </div>
    </div>
  );
};

export default DonutChart;
